import React, { useState } from 'react';

import { MainContainer } from '../../../components/MainContainer/MainContainer';
import { Button } from '../../../components/Button/Button';
import { Loading } from '../../../components/Loading/Loading';
import { useGetTgSessionsQuery } from '../../../redux/services/TgSessionsApi';
import SessionsTable from './components/SessionsTable';
import SessionLoginModal from './components/SessionLoginModal';
import styles from './TgSessions.module.css';

export const TgSessions = () => {
  const { data: sessions, isLoading, isError, refetch } = useGetTgSessionsQuery(undefined, { pollingInterval: 15000 });
  const [addActive, setAddActive] = useState(false);
  if (isLoading) {
    return <Loading />;
  }
  if (isError) {
    return (
      <MainContainer>
        <div className={'cards'}>
          <div className={styles.wrapper}>
            <h1>Сессии в ТГ</h1>
            <p className={styles.error}>Не удалось загрузить Telegram-аккаунты.</p>
            <Button text={'Повторить'} action={refetch} />
          </div>
        </div>
      </MainContainer>
    );
  }
  return (
    <MainContainer>
      <div className={'cards'} style={{ height: '100%', position: 'relative' }}>
        <div className={styles.wrapper}>
          <Button
            text={'Добавить аккаунт'}
            style={{ position: 'absolute', right: '24px', width: '180px' }}
            action={() => setAddActive(true)}
          />
          <h1>Сессии в ТГ</h1>
          <p className={styles.hint}>
            Подключите Telegram-аккаунт, в который приходят уведомления банка (например, от ботов Uzcard или Humo).
            Заявки на привязанные реквизиты будут подтверждаться автоматически.
          </p>
          <SessionsTable sessions={sessions || []} />
          {addActive && <SessionLoginModal active={addActive} setActive={setAddActive} />}
        </div>
      </div>
    </MainContainer>
  );
};
